<template>
  <el-dialog class="leave-detail" title="请假详情" :visible="detailShow" width="700px" center :close-on-click-modal="false"
    @open="dialogOpen" @close="dialogClose">
    <el-descriptions class="margin-top" title="" :column="2" border direction="horizontal">
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          姓名
        </template>
        {{ leaveDetail.studentName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-postcard"></i>
          学号 </template>{{ leaveDetail.studentNumber }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="iconfont icon-bindClass"></i>
          班级
        </template>
        {{ leaveDetail.className }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="iconfont icon-leave-type"></i>
          请假类型
        </template>
        {{ leaveDetail.leaveTypes }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          开始时间
        </template>
        {{ leaveDetail.startTime }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          结束时间
        </template>
        {{ leaveDetail.endTime }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-timer"></i>
          请假时长
        </template>
        {{ leaveLength }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-edit-outline"></i>
          审批状态
        </template>
        {{
          leaveDetail.status == 1
            ? "待审批中"
            : leaveDetail.status == 2
              ? "审批通过"
              : leaveDetail.status == 3
                ? "审批拒绝"
                : ""
        }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions class="margin-top" title="" :column="1" border direction="vertical">
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-tickets"></i>
          请假事由
        </template>
        {{ leaveDetail.content }}
      </el-descriptions-item>
      <el-descriptions-item v-if="imgList.length != 0">
        <template slot="label">
          <i class="el-icon-picture-outline"></i>
          请假图片
        </template>
        <div class="img-list" v-show="imgList.length != 0">
          <el-image v-for="(item, index) in imgList" :src="item" :key="index" :preview-src-list="imgList"></el-image>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions class="margin-top" title="" :column="1" border direction="vertical">
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-tickets"></i>
          审核记录
        </template>
        <!-- <span v-for="item, index in leaveDetail.reviews" :key="index">{{ item.reviewRank + item.auditorName }} </span> -->
        <el-table :data="leaveDetail.reviews" style="width: 100%;" height="200px">
          <el-table-column prop="auditorName" label="审核人" width="100px">
          </el-table-column>
          <el-table-column prop="createTime" label="审核时间" width="160px">
          </el-table-column>
          <el-table-column prop="status" label="审核操作" width="100px">
            <template slot-scope="scope">
              {{ scope.row.status == '1' ? "同意" : "拒绝" }}
            </template>
          </el-table-column>
          <el-table-column prop="feedback" label="审核意见">
          </el-table-column>
        </el-table>
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    detailShow: {
      type: Boolean,
      default: false,
    },
    leaveDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      imgList: [],
    };
  },
  computed: {
    // 请假时长
    leaveLength() {
      let timestamp = this.leaveDetail.endTimes - this.leaveDetail.startTimes;
      return this.getTime(timestamp);
    },
  },
  methods: {
    dialogOpen() {
      // console.log(this.leaveDetail);
      if (this.leaveDetail.imgList && this.leaveDetail.imgList.length) {
        this.imgList = this.leaveDetail.imgList.split(",");
      }
    },
    dialogClose() {
      this.imgList = [];
      this.$emit("update:detailShow", false);
    },
    // 时间戳转换
    getTime(timestamp) {
      let d = parseInt(timestamp / 60 / 60 / 24);
      // d = d < 10 ? "0" + d : d;
      let h = parseInt((timestamp / 60 / 60) % 24);
      // h = h < 10 ? "0" + h : h;
      let m = parseInt((timestamp / 60) % 60);
      // m = m < 10 ? "0" + m : m;
      let s = parseInt(timestamp % 60);
      // s = s < 10 ? "0" + s : s;
      return `${d}天${h}时${m}分`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./leave-detail.scss";
</style>
